import '../assets/NcLoadingIcon-CFmftMkz.css';
import { n as t } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const n = {
  name: "NcLoadingIcon",
  props: {
    /**
     * Specify the size of the loading icon.
     */
    size: {
      type: Number,
      default: 20
    },
    /**
     * The appearance of the loading icon.
     * 'auto' adjusts to the Nextcloud color scheme,
     * 'light' and 'dark' are static.
     */
    appearance: {
      type: String,
      validator(e) {
        return ["auto", "light", "dark"].includes(e);
      },
      default: "auto"
    },
    /**
     * Specify what is loading.
     */
    name: {
      type: String,
      default: ""
    }
  },
  computed: {
    colors() {
      const e = ["#777", "#CCC"];
      return this.appearance === "light" ? e : this.appearance === "dark" ? e.reverse() : ["var(--color-loading-light)", "var(--color-loading-dark)"];
    }
  }
};
var o = function() {
  var a = this, r = a._self._c;
  return r("span", { staticClass: "material-design-icon loading-icon", attrs: { "aria-label": a.name, role: "img" } }, [r("svg", { attrs: { width: a.size, height: a.size, viewBox: "0 0 24 24" } }, [r("path", { attrs: { fill: a.colors[0], d: "M12,4V2A10,10 0 1,0 22,12H20A8,8 0 1,1 12,4Z" } }), r("path", { attrs: { fill: a.colors[1], d: "M12,4V2A10,10 0 0,1 22,12H20A8,8 0 0,0 12,4Z" } }, [a.name ? r("title", [a._v(a._s(a.name))]) : a._e()])])]);
}, i = [], l = /* @__PURE__ */ t(
  n,
  o,
  i,
  !1,
  null,
  "626664cd",
  null,
  null
);
const c = l.exports;
export {
  c as default
};
